import { useQueueStats } from "../api/useQueueStats";
import { Skeleton } from "@hub/ui/components/ui/skeleton";

export function StatsBar() {
  const { byStatus, overdue, loading } = useQueueStats();

  if (loading) {
    return (
      <div className="flex gap-4 p-4">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-16 w-36" />
        ))}
      </div>
    );
  }

  const chips = [
    { label: "Open", value: byStatus["open"] ?? 0, color: "text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20" },
    { label: "In Progress", value: byStatus["in_progress"] ?? 0, color: "text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-900/20" },
    { label: "Completed Today", value: byStatus["completed"] ?? 0, color: "text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20" },
    { label: "SLA Warning", value: overdue, color: overdue > 0 ? "text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20" : "text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800/20" },
  ];

  return (
    <div className="flex gap-4 p-4 border-b border-gray-200 dark:border-white/10">
      {chips.map((chip) => (
        <div
          key={chip.label}
          className={`flex items-center gap-3 px-4 py-2.5 rounded-lg ${chip.color}`}
        >
          <span className="text-2xl font-bold">{chip.value}</span>
          <span className="text-sm font-medium">{chip.label}</span>
        </div>
      ))}
    </div>
  );
}
